import { render, staticRenderFns } from "./limitSales.vue?vue&type=template&id=617f5895&scoped=true"
import script from "./limitSales.vue?vue&type=script&lang=js"
export * from "./limitSales.vue?vue&type=script&lang=js"
import style0 from "./limitSales.vue?vue&type=style&index=0&id=617f5895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f5895",
  null
  
)

export default component.exports